export enum scoutsRecruitmentTypes {
  FETCH_SCOUTS_RECRUITMENT_REQUEST = "FETCH_SCOUTS_RECRUITMENT_REQUEST",
  FETCH_SCOUTS_RECRUITMENT_SUCCESS = "FETCH_SCOUTS_RECRUITMENT_SUCCESS",
  FETCH_SCOUTS_RECRUITMENT_FAILURE = "FETCH_SCOUTS_RECRUITMENT_FAILURE",
}